// extracted by mini-css-extract-plugin
module.exports = {"highlight":"_2bdUARa4gXs9Eiq3ZDd7oj","actionWrap":"_37kIfSc7TTAPupVP4gaJ-6","praise":"_1aw2UgnSIUL1Mzh0pFNdPe","switchWrap":"tPvminEk4oNf66ilEESu2"};